module.exports = __webpack_public_path__ + "img/people15.8b114c9e.png";